// extracted by mini-css-extract-plugin
module.exports = {"list":"FormsOverviewList_list__GXDBE"};